import type { ContentfulPageResponseModel } from '~~/server/api/contentful/index.get';

export function isContentfulPageRedirectResponse(
  data: unknown
): data is ContentfulPageResponseModel & {
  redirect: NonNullable<ContentfulPageResponseModel['redirect']>;
} {
  if (data === null || typeof data !== 'object' || !('redirect' in data)) {
    return false;
  }

  const redirect = (data as { redirect?: unknown }).redirect;
  return (
    redirect !== null &&
    typeof redirect === 'object' &&
    'destination' in redirect &&
    typeof redirect.destination === 'string' &&
    redirect.destination.length > 0
  );
}
